import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { ChevronRight, Mail, MapPin, Phone } from "lucide-react";
function FooterQuickLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <p className="text-[12px] text-foreground/20 font-mono">No links configured.</p>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="group flex items-center gap-2 text-[12px] text-foreground/20 hover:text-foreground/100 transition-all duration-300">
            <ChevronRight className="size-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-secondary" />
            <span>{item.label}</span>
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const techDocs = [{
    title: "Portfolio",
    path: "/PrecisionPortfolioPage"
  }, {
    title: "Pricing",
    path: "/InvestmentPage"
  }, {
    title: "Contact",
    path: "/StartYourProjectPage"
  }];
  return <section data-section-id="253155" id="footer" className="bg-background text-foreground border-t border-border/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
            </Link>
            <p className="text-[12px] text-foreground/20 leading-relaxed font-default hover:text-foreground/100 transition-colors duration-300">
              Create CAD delivers digital craftsmanship through high-precision 3D jewelry modeling and professional wax printing services for the modern jeweler.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground uppercase tracking-widest text-[12px] mb-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-secondary rounded-md inline-block"></span>
              Navigation
            </h3>
            <MenuProvider menu_id="17">
              <FooterQuickLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground uppercase tracking-widest text-[12px] mb-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-secondary rounded-md inline-block"></span>
              Resources
            </h3>
            <ul className="space-y-3">
              {techDocs.map((doc, i) => <li key={i} data-index={i}>
                  <Link to={doc.path} className="group flex items-center gap-2 text-[12px] text-foreground/20 hover:text-foreground/100 transition-all duration-300">
                    <ChevronRight className="size-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-secondary" />
                    <span>{doc.title}</span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground uppercase tracking-widest text-[12px] mb-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-secondary rounded-md inline-block"></span>
              Connect
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-[12px] text-foreground/20 hover:text-foreground/100 transition-colors duration-300">
                <MapPin className="size-4 mt-0.5 shrink-0 text-secondary" />
                <span>Digital Studio • Worldwide Delivery</span>
              </li>
              <li className="flex items-center gap-3 text-[12px] text-foreground/20 hover:text-foreground/100 transition-colors duration-300">
                <Phone className="size-4 shrink-0 text-secondary" />
                <span>Request a Quote</span>
              </li>
              <li className="flex items-center gap-3 text-[12px] text-foreground/20 hover:text-foreground/100 transition-colors duration-300">
                <Mail className="size-4 shrink-0 text-secondary" />
                <span>hdemirtshyan93@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="border-t border-border/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[12px] text-foreground/20 font-mono">
            &copy; {currentYear} CREATE CAD. All rights reserved.
          </p>
          
          <div className="flex items-center gap-3 px-4 py-2 border border-border/10 bg-muted/5 rounded-md">
            <span className="relative flex size-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-secondary opacity-75"></span>
              <span className="relative inline-flex rounded-lg size-2.5 bg-secondary"></span>
            </span>
            <span className="text-[10px] font-mono text-foreground/40 uppercase tracking-widest">
              Designed for Precision
            </span>
          </div>
        </div>
      </div>
    </section>;
}